import Vue from 'vue'
import store from '../store'

export default {
  create (data) {
    return Vue.http.post(window.API_URL + 'doctors/consultation/create', data)
  },
  updateSummary (summary) {
    return Vue.http.post(window.API_URL + 'doctors/consultations/summary', {summary_notes: summary})
  },
  getConsultation (id) {
    return Vue.http.get(window.API_URL + 'doctors/consultation/' + id)
  },
  getMessages (consultationRequestId) {
    return Vue.http.get(window.API_URL + 'doctors/consultation_requests/' + consultationRequestId + '/fetch-messages')
  },

  getAllPatientMessages () {
    return Vue.http.get(window.API_URL + 'doctors/consultation_requests/fetch-all-patient-last-message')
  },

  createFollowUp (followUp) {
    return Vue.http.post(window.API_URL + 'doctors/consultation_followup_reminders', followUp)
  },
  // fetchAvailableDoctors () {
  //   return Vue.http.get(window.API_URL + 'doctors/available-doctors', {doctors_ids: ably.getPresentMembers('doctors_channel')})
  // },

  transferToNewDoctor (doctorId, consultationId) {
    return Vue.http.post(window.API_URL + 'doctors/transfer-to-doctor', {
      doctor_id: doctorId,
      consultation_id: consultationId
    })
  },

  uploadFile (formData, file, channelId) {
    return Vue.http.post(window.API_URL + 'doctors/customer/documents', formData, {
      progress (e) {
        if (e.lengthComputable) {
          file.progress = parseInt(e.loaded / e.total * 100)
          file.state = 'uploading'
          store.dispatch('message/documentUploadProgress', {file, channelId})
        }
      }
    })
  },

  endConsultation (requestId) {
    var credentials = {
      consultation_request_id: requestId,
      status: 'SUCCESS'
    }
    Vue.http.post(window.API_URL + 'doctors/consultation_requests/end', credentials)
  },

  endOfflineConsultation (data) {
    return Vue.http.post(window.API_URL + 'doctors/consultations/end_chat', data)
  },
  getCustomerPastConsultation (customerId, page, queries) {
    return Vue.http.get(window.API_URL + 'doctors/customers/past_consults?page=' +
    page + '&customer_id=' + customerId + '&fetch_queries=' + queries)
  },
  updateOfflineConsultation (consultId) {
    return Vue.http.patch(window.API_URL + 'doctors/consultations/' + consultId + '/accept')
  },

  fetchMesaagesConsultation (consultationId, consultationRequestId) {
    return Vue.http.get(window.API_URL +
      'doctors/customers/past_consults/fetch-messages?consultation_id=' +
      consultationId + '&consultation_request_id=' + consultationRequestId)
  },
  familyDoctorReplyToOfflineCustomer (messageId, consultationRequestId) {
    return Vue.http.post(window.API_URL + `doctors/consultation_requests/${consultationRequestId}/query_reply`, {chat_message: {unique_id: messageId}})
  },
  doctorReplyToOfflineCustomer (messageId, consultationRequestId) {
    return Vue.http.post(window.API_URL + `doctors/consultation_requests/${consultationRequestId}/doctor_reply`, {chat_message: {unique_id: messageId}})
  }
}



// WEBPACK FOOTER //
// ./src/api/consultation.js